module.exports = __webpack_public_path__ + "static/media/gen-04.a6776ced.png";